import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import "./adminHolidayCalender.css";

export default function AdminHolidayCalender({
  events,
  eventClick,
  onMonthChange,
}) {
  const renderEventContent = (eventInfo) => {
    const fullTitle = eventInfo.event.title;
    const shortTitle =
      fullTitle.length > 12 ? fullTitle.slice(0, 20) + "..." : fullTitle;

    return (
      <div className="custom-event" title={fullTitle}>
        {shortTitle}
      </div>
    );
  };

  return (
    <FullCalendar
      viewClassNames="event-calendar-view"
      allDayClassNames="events-all-day"
      dayHeaderClassNames="evetnts-day-header"
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
      initialView="dayGridMonth"
      fixedWeekCount={false}
      headerToolbar={{
        left: "prev,next",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
      }}
      views={{
        listWeek: {
          listDayFormat: { weekday: "long" },
          listDaySideFormat: {
            month: "short",
            day: "numeric",
            year: "numeric",
          },
        },
      }}
      eventContent={renderEventContent}
      events={events}
      eventColor="none"
      eventClick={eventClick}
      datesSet={(dateInfo) => {
        const year = dateInfo.view.currentStart.getFullYear();
        const month = (dateInfo.view.currentStart.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        const yearMonth = `${year}-${month}`;
        if (typeof onMonthChange === "function") {
          onMonthChange(yearMonth);
        }
      }}
    />
  );
}
